import type {
  CardapioCaixaNotification,
  CardapioCloseAccountPayload,
  CardapioMesaItemsPayload,
  CardapioWaiterPayload,
} from "@/lib/cardapioOperationalNotifications";

async function handleJson<T>(res: Response): Promise<T> {
  const text = await res.text();
  const trimmed = text.trim();
  if (!trimmed) {
    if (res.ok) return {} as T;
    throw new Error("Erro na requisição");
  }
  let data: unknown;
  try {
    data = JSON.parse(trimmed);
  } catch {
    throw new Error("Resposta inválida do servidor");
  }
  if (!res.ok || (data && typeof data === "object" && "ok" in data && (data as { ok?: boolean }).ok === false)) {
    const obj = data && typeof data === "object" ? (data as Record<string, unknown>) : null;
    const msg =
      obj && typeof obj.error === "string"
        ? obj.error
        : obj && typeof obj.message === "string"
          ? obj.message
          : "Erro na requisição";
    throw new Error(msg);
  }
  return data as T;
}

export type GarcomWaiterChamado = CardapioCaixaNotification & {
  tipo: "waiter_request";
  payload: CardapioWaiterPayload;
};

export type GarcomMesaItemsNotification = CardapioCaixaNotification & {
  tipo: "mesa_items";
  payload: CardapioMesaItemsPayload;
};

export type GarcomCloseAccountNotification = CardapioCaixaNotification & {
  tipo: "close_account";
  payload: CardapioCloseAccountPayload;
};

export type GarcomChamado = GarcomWaiterChamado | GarcomMesaItemsNotification | GarcomCloseAccountNotification;

export async function listarGarcomChamados(options?: { signal?: AbortSignal }): Promise<GarcomChamado[]> {
  const res = await fetch("/api/garcom/chamados/list.php", {
    credentials: "include",
    method: "GET",
    cache: "no-store",
    signal: options?.signal,
    headers: { Accept: "application/json" },
  });
  const data = await handleJson<{ chamados?: GarcomChamado[] }>(res);
  return (data.chamados ?? []).filter((c) => c.tipo === "waiter_request" || c.tipo === "mesa_items" || c.tipo === "close_account");
}

export async function confirmarGarcomChamado(id: number): Promise<void> {
  const res = await fetch("/api/garcom/chamados/dismiss.php", {
    credentials: "include",
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ id }),
  });
  await handleJson(res);
}
